// CheckBox.js
import React from 'react';

const CheckBox = ({ label, onChange, checked, id }) => {
  return (
    <div className="form-check mb-4">
      <input 
        type="checkbox" 
        className="form-check-input fs-4 transition duration-300 transform hover:scale-110 focus:ring-2 focus:ring-primary focus:outline-none" 
        onChange={onChange} 
        checked={checked} 
        id={id}  // Уникальный id для правильной связи с label
      />
      <label 
        className="form-check-label fs-4 transition duration-300 transform hover:scale-110 focus:ring-2 focus:ring-primary focus:outline-none" 
        htmlFor={id}  // Привязываем метку к id
      >
        {label}
      </label>
    </div>
  );
};

export default CheckBox;
